import { render } from "./actions-repeater.vue?vue&type=template&id=5a89133a"
import script from "./actions-repeater.vue?vue&type=script&lang=js"
export * from "./actions-repeater.vue?vue&type=script&lang=js"

import "./actions-repeater.vue?vue&type=style&index=0&id=5a89133a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__